import type { HelpArticlePage } from "../types";
import { localizePath } from "@/lib/locale";
import { breadcrumbJsonLd, jsonLdScript, pageMeta, SITE_NAME } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";
import { getLocale, getUrlOrigin } from "@/paraglide/runtime.js";

/** One help article's title, description and, for search engines, the article and where it sits. */
export const helpArticleHead = (article: HelpArticlePage) => {
  const urlOf = (path: string) => `${getUrlOrigin()}${localizePath(path, getLocale())}`;
  const url = urlOf(`/help/${article.slug}`);

  return {
    meta: pageMeta({ title: article.title, description: article.summary || undefined }),
    scripts: [
      jsonLdScript({
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.title,
        description: article.summary || undefined,
        url,
        mainEntityOfPage: url,
        dateModified: article.updatedAt,
        // An article not translated yet is shown in its own language, so that is the one to name.
        inLanguage: article.language,
        publisher: { "@type": "Organization", name: SITE_NAME, url: `${getUrlOrigin()}/` },
      }),
      breadcrumbJsonLd([
        { name: m.help_title(), url: urlOf("/help") },
        { name: article.title, url },
      ]),
    ],
  };
};
